import { useMemo } from "react";
import { useTeams } from "../ducks/data/teams/hooks";
import { DoraSelect } from "dora-shared/frontend";
import { useTranslation } from "react-i18next";
import { faUsers } from "@fortawesome/free-solid-svg-icons";

const TeamSelector = (props: {
  value: string;
  onChange: (teamId: string) => void;
}) => {
  const { t } = useTranslation("dispatching");
  const teams = useTeams();
  const teamOptions = useMemo(
    () => teams.map(({ id, name }) => ({ value: id, label: name })),
    [teams]
  );
  return (
    <DoraSelect
      fullWidth
      options={teamOptions}
      value={props.value || undefined}
      label={t("routesTopBar.assignedTeam")}
      icon={faUsers}
      onChange={(teamId) => {
        if (teamId) props.onChange(teamId);
      }}
    />
  );
};

export default TeamSelector;
